import { createTheme } from '@one-thd/sui-atomic-components';

const FathersDaySecondaryTwo = createTheme({
  palette: {
    mode: 'light',
    background: {
      primary: 'brand'
    }
  }
});

FathersDaySecondaryTwo.palette['--sui-palette-background-primary'] = '219 205 191';

export { FathersDaySecondaryTwo };
